// removed by extract-text-webpack-plugin
module.exports = {"cta":"KMWk"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/CtaTopRight/CtaTopRight.scss
// module id = Ibbr
// module chunks = 0